import { useNavigate, useParams } from "react-router";

import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import { CoInvestmentFullPaths } from "@vega-modules/paths";

import { CoInvestmentPageHeader } from "../components/CoInvestmentPageHeader/CoInvestmentPageHeader";
import { DataRoomPermissions } from "../components/DataRoomPermissions/DataRoomPermissions";
import { useDataRoomData } from "../hooks/useDataRoomData";
import { useDealName } from "../hooks/useDealName";

export const DataRoomPage = () => {
  const { id: dealIdParams } = useParams<{ id: string }>();
  const dealId = dealIdParams ?? "";
  const navigate = useNavigate();

  const { featureFlag } = useFeatureFlag();
  const isNewNavEnabled =
    featureFlag[FeatureFlag.GP_COINVEST_NEW_UI_NAV_VD_25769];

  const { dealName, isLoading: isDealNameLoading } = useDealName(dealId);
  const { dataRoomName, isLoading: isDataRoomLoading } =
    useDataRoomData(dealId);
  const isLoading = isDealNameLoading || isDataRoomLoading;

  return (
    <div
      className="mt-1 mx-auto pb-16"
      data-testid="co-investments-data-room-v2"
    >
      <CoInvestmentPageHeader
        backButtonDataTestId="back-to-configure-button"
        capitalize={false}
        fundName={dealName}
        isLoading={isLoading}
        onBack={
          isNewNavEnabled
            ? () =>
                navigate(
                  CoInvestmentFullPaths.CoInvestmentConfigure.replace(
                    ":id",
                    dealId,
                  ),
                )
            : undefined
        }
        showClosedDealNotice
        showDrawer={!isNewNavEnabled}
        title={dataRoomName}
      />
      <DataRoomPermissions className="mt-4" dealId={dealId} />
    </div>
  );
};
